"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBookingOrderSlot = void 0;
class UpdateBookingOrderSlot {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.updateBookingOrderSlot(request);
    }
}
exports.UpdateBookingOrderSlot = UpdateBookingOrderSlot;
